import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationDetailWithContainersFragmentDoc } from '../fragments/containerStationDetailWithContainers.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContainerStationWithContainersQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetContainerStationWithContainersQuery = { __typename?: 'Query', containerStation: { __typename?: 'ContainerStation', id: string, name: string, store_id: string, epc_tag: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null }, store: { __typename?: 'Store', id: string, name?: string | null }, containers: Array<{ __typename?: 'ContainerStationContainer', id: string, name: string, owner_since: string, type_id: number, type_name: string, image_url?: string | null, size_helper?: string | null, status: Types.ContainerLocationStatus }> } };


export const GetContainerStationWithContainersDocument = gql`
    query GetContainerStationWithContainers($id: ID!) {
  containerStation(id: $id) {
    ...ContainerStationDetailWithContainers
  }
}
    ${ContainerStationDetailWithContainersFragmentDoc}`;

/**
 * __useGetContainerStationWithContainersQuery__
 *
 * To run a query within a React component, call `useGetContainerStationWithContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerStationWithContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerStationWithContainersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContainerStationWithContainersQuery(baseOptions: Apollo.QueryHookOptions<GetContainerStationWithContainersQuery, GetContainerStationWithContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerStationWithContainersQuery, GetContainerStationWithContainersQueryVariables>(GetContainerStationWithContainersDocument, options);
      }
export function useGetContainerStationWithContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerStationWithContainersQuery, GetContainerStationWithContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerStationWithContainersQuery, GetContainerStationWithContainersQueryVariables>(GetContainerStationWithContainersDocument, options);
        }
export type GetContainerStationWithContainersQueryHookResult = ReturnType<typeof useGetContainerStationWithContainersQuery>;
export type GetContainerStationWithContainersLazyQueryHookResult = ReturnType<typeof useGetContainerStationWithContainersLazyQuery>;
export type GetContainerStationWithContainersQueryResult = Apollo.QueryResult<GetContainerStationWithContainersQuery, GetContainerStationWithContainersQueryVariables>;